import { Tenant } from "./tenant";

export class Decoder {
  name: string;
  type: string;
  source: string;
  routingKey: string;
  creationDate: number;
  updatedDate: number;
  tenant: Tenant;
}
